import { isSharedUserMaterial, LtiSharedUserMaterial, LtiUserMaterial } from '../../api/user-material';

export function buildLtiExerciseMaterial(material: LtiUserMaterial | LtiSharedUserMaterial) {
  const { assignment, ...rest } = material;

  const baseLtiExercise = {
    ...rest,
    module: rest.moduleId,
    moduleId: undefined,
    needsGrading: material.needsGrading || false,
  };

  if (!isSharedUserMaterial(material)) return baseLtiExercise;

  if (material.assignment) {
    return {
      ...baseLtiExercise,
      assignment: {
        id: material.assignment.id,
        repeatable: material.assignment.repeatable,
        schoolName: material.assignment.schoolName,
        groupName: material.assignment.groupName,
      },
    };
  }

  if (material.shares?.length) {
    return {
      ...baseLtiExercise,
      share: material.shares[0],
    };
  }

  return baseLtiExercise;
}
